import LocationUtils from "../util/location-utils";

class Announcement {

    constructor(root) {
        this.container = root;
        this.userZipInput = this.container.querySelector('input[type="search"]');
        this.zipForm = this.container.querySelector('.announcement form.zip-entry');

        this.userZipInput.addEventListener('focus', () => {
            this.userZipInput.setSelectionRange(0, this.userZipInput.value.length);
        });
        this.userZipInput.addEventListener('input', () => {
            this.sizeZipInputToValue();
        });

        // (SW): The search event listener is not supported in Firefox
        // this.userZipInput.addEventListener('search', e => {
        //   console.log('detected user input');
        //     e.preventDefault();
        //     let value = e.target.value;
        //     LocationUtils.writeZipCookie(value);
        //     location.reload();
        // });

        this.zipForm.addEventListener('submit', e => {
            e.preventDefault();
            let value = this.userZipInput.value;
            LocationUtils.writeZipCookie(value);
            location.reload();
        });

        this.sizeZipInputToValue();
    }

    sizeZipInputToValue() {
        let value = this.userZipInput.value;
        if(value.length === 0) {
            value = this.userZipInput.getAttribute('placeholder');
        }

        const span = document.createElement('span');
        span.style.visibility = 'hidden';
        span.classList.add('cta');
        span.innerText = value;
        document.body.append(span);

        const width = span.getBoundingClientRect().width;
        document.body.removeChild(span);

        this.userZipInput.style.width = `${width + 3}px`;
    }
}

export {Announcement}